import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { retrieveFolloweesOpinions } from 'common/api/GraphApi';
import { FOLLOWEES_RATING } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import get from 'common/tools/objects/get';
import trans from 'common/tools/translations/trans';

import onlyIfHasSocial from 'website/components/HoC/onlyIfHasSocial';
import allocineContainer from 'website/containers/allocineContainer';

import FolloweeRatingDetail from './FolloweeRatingDetail';
import FolloweeWantToSeeDetail from './FolloweeWantToSeeDetail';
import styles from './styles.module.scss';

// The list generated by GraphQL is already sorted by date, from most recent to oldest.
// This sort the list by descending rating value.
const sortFollowees = (followeeA, followeeB) => {
  const valueA = get(followeeA, ['action', 'content', 'rating']);
  const valueB = get(followeeB, ['action', 'content', 'rating']);
  return valueB - valueA;
};

class FolloweesRatingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      followeesRatings: [],
      followeesWantToSee: []
    };
  }

  async componentDidMount() {
    const response = await retrieveFolloweesOpinions(this.props.entity.id);

    const followeesRatings = [];
    const followeesWantToSee = [];
    const followeesActions = get(response, [
      'me',
      'user',
      'social',
      'followeesActions'
    ]);

    followeesActions
      .filter(followee => {
        return followee.action.__typename === 'Opinion';
      })
      .sort(sortFollowees)
      .forEach(relationship => {
        followeesRatings.push({
          action: {
            ...relationship.action,
            // Trick to get if the review exist without get all the review.
            // It's temporary before revision of review object in GraphQl
            hasReview: /(PUBLISHED|ACCEPTED)/gi.test(
              relationship.action.content.status
            )
          },
          user: relationship.user
        });
      });

    followeesActions
      .filter(followee => {
        return followee.action.__typename === 'WantToSee';
      })
      .sort(sortFollowees)
      .forEach(relationship => {
        followeesWantToSee.push(relationship);
      });
    this.setState({
      followeesRatings: followeesRatings,
      followeesWantToSee: followeesWantToSee
    });
  }

  render() {
    const { entity } = this.props;
    const { followeesRatings, followeesWantToSee } = this.state;

    const ratingsRendered = [];
    const wantToSeeRendered = [];

    followeesRatings.forEach(followee => {
      const opinion = {
        rating: followee.action.content.rating,
        hasReview: followee.action.hasReview
      };

      ratingsRendered.push(
        <FolloweeRatingDetail
          opinion={opinion}
          user={followee.user}
          key={followee.user.legacyId}
          entityId={entity.legacyId}
          entityType={entity.typename}
        />
      );
    });

    let wantToSeePart = null;
    if (followeesWantToSee.length) {
      followeesWantToSee.forEach(followee => {
        wantToSeeRendered.push(
          <FolloweeWantToSeeDetail
            user={followee.user}
            key={followee.user.legacyId}
          />
        );
      });

      wantToSeePart = (
        <>
          <h2
            className={classNames(styles.modalSecondTitle, 'titlebar-title')}
            /* eslint-disable react/no-danger */
            dangerouslySetInnerHTML={{
              __html: trans('rating.modal.second-title', {
                entity: this.props.entity.title
              })
            }}
            /* eslint-enable react/no-danger */
          />
          {wantToSeeRendered}
        </>
      );
    }

    return (
      <ReactModal
        size="medium"
        className="modal-followees-rating"
        title={trans('rating.labelfriends')}
      >
        {ratingsRendered}
        {wantToSeePart}
      </ReactModal>
    );
  }
}

FolloweesRatingModal.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    legacyId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    typename: PropTypes.string.isRequired
  }).isRequired
};

export default buildReactDomModalModule(FOLLOWEES_RATING, (params = {}) => {
  const ConnectedFolloweesRatingModal = allocineContainer(
    onlyIfHasSocial(FolloweesRatingModal)
  );
  return <ConnectedFolloweesRatingModal entity={params.entity} />;
});
